import React from "react"

import { Form, Formik } from "formik"
import { gql } from "urql"

import { useMutation } from "hooks/urql"

import {
  FormFailures,
  SubmitButton,
  handleFailure,
} from "components/Forms/Formik/hookComponents"
import ModalWithProvidedBody from "components/ModalWithProvidedBody"

const RemoveInterviewer = ({ id }) => {
  const formState = {}
  const [, removeInterviewer] = useMutation(removeInterviewerMutation)

  const handleSubmit = (values, actions) => {
    removeInterviewer({ id })
      .then(
        response => {
          const { failures, redirectTo } =
            response.data.removeTutorApplicationInterviewer
          if (redirectTo) {
            window.location.href = redirectTo
          } else {
            handleFailure(actions, failures)
          }
        },
        () => handleFailure(actions)
      )
      .catch(() => handleFailure(actions))
  }

  return (
    <ModalWithProvidedBody
      modalTitle="Remove Interviewer"
      buttonText="Remove Interviewer"
      buttonClassName="btn btn-danger"
    >
      {({ closeModal }) => (
        <Formik initialValues={formState} onSubmit={handleSubmit}>
          <Form>
            <div className="modal-body">
              <p className="alert alert-danger">
                Are you sure? This will permanently remove this interviewer!
              </p>
            </div>

            <div className="modal-footer flex-col">
              <FormFailures />
              <div className="w-100 flex justify-between">
                <button type="button" className="btn" onClick={closeModal}>
                  Cancel
                </button>
                <SubmitButton text="Remove" className="btn btn-danger" />
              </div>
            </div>
          </Form>
        </Formik>
      )}
    </ModalWithProvidedBody>
  )
}

const removeInterviewerMutation = gql`
  mutation ($id: ID!) {
    removeTutorApplicationInterviewer(tutorApplicationInterviewerId: $id) {
      redirectTo
      failures {
        message
      }
    }
  }
`

export default RemoveInterviewer
